import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';
import { AppProvider } from '../../App';
import Modal from '../../components/modal/Modal';
import ModalProvider from '../../components/modal/ModalContext';
import TakesStateProvider from '../../helpers/takesHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { clearUserIdentity, identifyUser } from '../../utils';
import ContractsTable from '../Contracts/Contracts';
import MobileView from '../Mobile/MobileView';
import Profiles from '../Profiles/Profiles';
import Invite from '../Reviews/Tabs/Invite';
import Settings from '../Settings/Settings';
import './MainApp.scss';
import ProfileRoutes from './ProfileRoutes';
import ProtectedRoute from './ProtectedRoute';
import TakeRoutes from './TakeRoutes';
import TwitterCallback from './TwitterCallback';

function HomeRedirect() {
  const [{ user }] = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if the user is logged in and at the base URL.
    if (user && location.pathname === '/') {
      navigate(`/takes/feed`);
    }
  }, [user, location.pathname, navigate]);

  return null;
}

function InvalidRouteRedirect() {
  const [{ user }] = useGlobalState();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(`/profile/${user.address}/projects`);
    } else {
      navigate('/takes/feed');
    }
  }, [user, navigate]);

  return null;
}

const AppRoutes = () => {
  const { width } = useWindowSize();
  return (
    <>
      {width > 800 ? (
        <>
          <Routes>
            <Route element={<AppProvider />}>
              <Route path='/' element={<HomeRedirect />} />

              {TakeRoutes()}
              {ProfileRoutes()}
              <Route
                path='/profiles'
                element={
                  <ProtectedRoute>
                    <Profiles />
                  </ProtectedRoute>
                }
              />

              <Route path='/twitterCallback' element={<TwitterCallback />} />
              <Route
                path='/invite'
                element={
                  <ProtectedRoute>
                    <Invite />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/settings'
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />

              <Route path='*' element={<InvalidRouteRedirect />} />
            </Route>
            <Route path='/contracts/:platform' element={<ContractsTable />} />
          </Routes>
        </>
      ) : (
        <MobileView />
      )}
    </>
  );
};

const MainApp = () => {
  const [{ user }] = useGlobalState();

  useEffect(() => {
    if (user) {
      identifyUser(user?.address);
    }
    return () => {
      if (user) {
        clearUserIdentity();
      }
    };
  }, [user]);

  return (
    <TakesStateProvider>
      <ModalProvider>
        <AppRoutes />
        <Modal />
      </ModalProvider>
    </TakesStateProvider>
  );
};

export default MainApp;
